function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useMemo, useEffect, useRef, useCallback } from 'react';
import Trigger from 'rc-trigger';
import classNames from 'classnames';
import { InputNumber } from 'mkui-fd';
Trigger.displayName = 'Trigger';
var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 4]
  },
  topLeft: {
    points: ['bl', 'tl'],
    offset: [0, -4]
  },
  bottomRight: {
    points: ['tr', 'br'],
    offset: [0, 4]
  },
  topRight: {
    points: ['br', 'tr'],
    offset: [0, -4]
  }
};
var POPUP_ALIGN = {
  overflow: {
    adjustX: 1,
    adjustY: 1
  }
};
var prefixCls = 'mkui-amount-range-picker-button';
var POPUP_PLACEMENT = 'bottomLeft';
export default function AmountRangPickerButton(props) {
  var disabled = props.disabled,
      onChange = props.onChange,
      value = props.value,
      placeholder = props.placeholder,
      placement = props.placement,
      precision = props.precision;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = useState(value),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  useEffect(function () {
    setInputValue(value);
  }, [value]);
  var getPopupContainer = useCallback(function () {
    return document.body;
  }, []);

  var onDropdownVisibleChange = function onDropdownVisibleChange(visible) {
    setVisible(visible);

    if (visible === false) {
      if (onChange) {
        onChange(inputValue);
      }
    }
  };

  var startValueChangeHandle = function startValueChangeHandle(value) {
    if (!inputValue) {
      setInputValue([value, null]);
    } else {
      setInputValue([value, inputValue[1]]);
    }
  };

  var endValueChangeHandle = function endValueChangeHandle(value) {
    if (!inputValue) {
      setInputValue([null, value]);
    } else {
      setInputValue([inputValue[0], value]);
    }
  };

  var getDropdownElement = function getDropdownElement() {
    return React.createElement("div", {
      className: "".concat(prefixCls)
    }, React.createElement(InputNumber, {
      theme: "surround",
      onChange: startValueChangeHandle,
      precision: precision
    }), React.createElement("span", {
      className: "".concat(prefixCls, "-split")
    }, "-"), React.createElement(InputNumber, {
      theme: "surround",
      onChange: endValueChangeHandle,
      precision: precision
    }));
  };

  var renderButton = function renderButton() {
    var start = inputValue && inputValue[0];
    var end = inputValue && inputValue[1];
    return React.createElement("span", {
      className: classNames(props.className, prefixCls)
    }, React.createElement("button", {
      disabled: disabled
    }, !start && !end ? placeholder : (start || '') + '~' + (end || '')));
  };

  return React.createElement(Trigger, {
    showAction: disabled ? [] : ['click'],
    hideAction: ['click'],
    popupPlacement: POPUP_PLACEMENT,
    builtinPlacements: BUILT_IN_PLACEMENTS,
    prefixCls: "".concat(prefixCls, "-dropdown-wrapper"),
    popup: getDropdownElement(),
    mask: true,
    getPopupContainer: getPopupContainer,
    onPopupVisibleChange: onDropdownVisibleChange,
    popupVisible: visible,
    popupAlign: POPUP_ALIGN,
    zIndex: 9999
  }, renderButton());
}
//# sourceMappingURL=AmountRangPickerButton.js.map
